var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 20.5,
    fill: "#FCF2F3",
    stroke: "url(#paint0_linear_4186_6184)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 17L21.5 22L13.5 17V15L21.5 20L29.5 15V17ZM29.5 13H13.5C12.39 13 11.5 13.89 11.5 15V27C11.5 27.5304 11.7107 28.0391 12.0858 28.4142C12.4609 28.7893 12.9696 29 13.5 29H29.5C30.0304 29 30.5391 28.7893 30.9142 28.4142C31.2893 28.0391 31.5 27.5304 31.5 27V15C31.5 13.89 30.6 13 29.5 13Z",
    fill: "#C7222A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4186_6184",
    x1: 21.5,
    y1: 1,
    x2: 21.5,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.4470d8b74e4a2ec7467cb8fe1141a5e4.svg";
export { ForwardRef as ReactComponent };